import Card from '@mui/material/Card';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from 'react-router';
import { Fragment } from 'react';

import type { BreadCrumbComponentProps } from '../../../../types';

/**
 * A component that renders a breadcrumb navigation path
 *
 * @component
 * @param {BreadCrumbComponentProps} props - The component props
 * @param {ISection & { breadcrumb?: ISection[] }} props.breadcrumb - The current section with its breadcrumb path
 * @param {function} props.navigateTo - Callback function that handles navigation when a breadcrumb is clicked
 * @returns {JSX.Element|null} The breadcrumb navigation UI or null if no breadcrumb path exists
 */
const BreadCrumbComponent: React.FC<BreadCrumbComponentProps> = ({
  breadcrumb,
  navigateToCategory,
}) => {
  if (!breadcrumb?.breadcrumb) {
    return null;
  }

  const breadcrumbPath = breadcrumb.breadcrumb;

  return (
    <Card variant="outlined" className="breadcrumb-card-section">
      <nav>
        {breadcrumbPath.map((section, index) => (
          <Fragment key={section.code}>
            <Link
              key={section.code}
              to=""
              onClick={() => navigateToCategory(section)}
              className={index === breadcrumbPath.length - 1 ? 'active' : 'not-active'}
            >
              {section.description}
            </Link>
            {index < breadcrumbPath.length - 1 && (
              <ChevronRightIcon fontSize="small" style={{ margin: '0 4px' }} />
            )}
          </Fragment>
        ))}
      </nav>
    </Card>
  );
};

export default BreadCrumbComponent;
